import React from 'react';
import PropTypes from 'prop-types';

import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { sortDirection } from 'utils/constants';

const useStyles = makeStyles(theme => ({
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

const EnhancedTableHead = props => {
    const { headCells, direction: tableDirection, orderBy, handleSort } = props;
    const classes = useStyles();

    const direction =
        tableDirection === 'warning' || tableDirection === 'critical' ? 'asc' : tableDirection;

    const handleSortTable = property => () => {
        const isAsc = direction === sortDirection.ASC && orderBy === property;
        const newDirection = isAsc ? sortDirection.DESC : sortDirection.ASC;
        handleSort(property, newDirection);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell =>
                    headCell.isSortable ? (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            sortDirection={orderBy === headCell.id ? direction : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? direction : sortDirection.ASC}
                                onClick={handleSortTable(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {direction === sortDirection.DESC
                                            ? 'sorted descending'
                                            : 'sorted ascending'}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ) : (
                        <TableCell key={headCell.id}>{headCell.label}</TableCell>
                    )
                )}
            </TableRow>
        </TableHead>
    );
};

EnhancedTableHead.propTypes = {
    headCells: PropTypes.array.isRequired,
    direction: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    handleSort: PropTypes.func,
};

export default EnhancedTableHead;
